import { render } from "./PagePreviewRenderer.vue?vue&type=template&id=71bf20cd&scoped=true"
import script from "./PagePreviewRenderer.vue?vue&type=script&lang=js"
export * from "./PagePreviewRenderer.vue?vue&type=script&lang=js"

import "./PagePreviewRenderer.vue?vue&type=style&index=0&id=71bf20cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bf20cd"]])

export default __exports__